import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { vessel } from '../Vessel';

export const useVesselPositions = () =>
  useQuery({
    queryKey: [QUERY_KEYS.vesselPositions],
    queryFn: async () => (await vessel.getVesselPositions()).data,
  });
